<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <LineRepairList v-if='selectedIndex === 0'/>
    <MachineRepairStatistics v-if='selectedIndex === 1'/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import LineRepairList from './LineRepairList'
import MachineRepairStatistics from './MachineRepairStatistics'

export default {
  name: 'bom-tab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: []
    }
  },
  components: {
    DxTabPanel,
    LineRepairList,
    MachineRepairStatistics
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    console.log(user)
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
